import styled from "styled-components"

export const ListWrapper = styled.section`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  max-width: 1180px;
  margin: 0 auto 30px;
`
